export default __webpack_public_path__ + "static/media/bluecherry-footer-logo-white.aa8e02da.svg";